<section class="testi">
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <h2 class="heading-clr">Businesses which trusted <span>Daton</span> recently</h2>
      </div>
      <div class="col-md-8 col-center m-auto">
        <div id="myCarousel" class="carousel slide" data-ride="carousel">
          <ol class="carousel-indicators">
            <li data-target="#myCarousel" *ngFor="let business of trustedBusinesses let i = index"
                [ngClass]="{'active' : i == 0}" [attr.data-slide-to]="i"></li>
          </ol>
          <div class="carousel-inner">
            <div class="item carousel-item" *ngFor="let business of trustedBusinesses; let i = index"
                 [ngClass]="{'active' : i == 0}">
              <img [src]="business.image_url" class="carousel-image"/>
              <!-- <div class="carousel-text-block"><p class="carousel-text">{{business.testimonial}}</p></div>                   -->
            </div>
          </div>
          <a class="carousel-control left carousel-control-prev" href="#myCarousel" data-slide="prev">
            <i class="fa fa-angle-left"></i>
          </a>
          <a class="carousel-control right carousel-control-next" href="#myCarousel" data-slide="next">
            <i class="fa fa-angle-right"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
